import { CircularProgress } from '@mui/material';
import { getObjectListApi } from 'api/general';
import AgendaTemplateDataTable from 'app/components/DataTable/agendaTemplate/AgendaTemplateDataTable';
import LoadingPopUp from 'app/components/LoadingPopup';
import { sortByDate } from 'app/utils/appHelpers';
import { AGENDA_TEMPLATE } from 'app/utils/constants/customConstant';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getAgendaTemplatesAPI } from 'stores/general';

const AgendaTemplatePage = () => {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const allAgendaTemplates = useSelector(state => state.general.agendaTemplates);
    const agendaTemplatesLoading = useSelector(state => state.general.agendaTemplatesLoading);
    const { authUser } = useSelector(state => state.auth);

    useEffect(() => {
        const processData = () => {
            setLoading(true);

            let data = allAgendaTemplates;
            if (data && data.length > 0) data = data.filter(x => x.userId === authUser.id);
            data = sortByDate(data, "pdate", "desc")

            if (authUser) {
                data = data.filter(x => x.userId === authUser.id);
            }

            setData(data);
            setLoading(false);
        }

        if (!agendaTemplatesLoading) {
            processData();
        }
    }, [allAgendaTemplates, authUser, agendaTemplatesLoading])

    const columnData = [
        { id: 'user', align: 'center', disablePadding: false, label: "Kullanıcı" },
        { id: 'title', align: 'center', disablePadding: false, label: "Şablon Başlığı" },
        { id: 'body', align: 'center', disablePadding: false, label: "İçerik" },
        { id: 'pdate', align: 'center', disablePadding: false, label: "Güncelleme Tarihi" },
        { id: 'islemler', align: 'center', disablePadding: false, label: "İşlemler" }
    ];

    return (
        <React.Fragment>
            <>
                <LoadingPopUp open={loading || agendaTemplatesLoading} />
                {!loading && !agendaTemplatesLoading && <AgendaTemplateDataTable mainData={data} column={columnData} pageTitle="Gündem Şablonlarım" />}
            </>
        </React.Fragment>
    );
};

export default AgendaTemplatePage;